import { times } from 'number-precision'
import type { ParcelFormFields } from './types'
import { FormInstance } from 'antd-mobile/es/components/form/form'

type IformData = Pick<ParcelFormFields, 'parcel_commodities'> & {
  parcel_currency_code: string
}

export const getParcelTotalPriceWithForm = (inputForm?: FormInstance) => {
  const { parcel_commodities, parcel_currency_code } = inputForm?.getFieldsValue(true) || {}

  const parcelAmount =
    parcel_commodities?.reduce((acc, next) => {
      return (acc += times(next.parcel_goods_price, next.parcel_goods_quantity || 1))
    }, 0) || ''

  return {
    amount: typeof parcelAmount === 'number' ? times(parcelAmount, 100) : null,
    parcel_currency_code: parcel_currency_code as string,
  }
}

export const getParcelTotalPrice = (values: IformData) => {
  const { parcel_commodities, parcel_currency_code } = values || {}

  const parcelAmount =
    parcel_commodities?.reduce((acc, next) => {
      return (acc += times(next.parcel_goods_price, next.parcel_goods_quantity || 1))
    }, 0) || ''

  return {
    valueOfGoods: typeof parcelAmount === 'number' ? times(parcelAmount, 100) : null,
    valueOfGoodsCurrency: parcel_currency_code as string,
  }
}
